"use strict"
;(() => {
    const form = document.querySelector(".filter-benefits-form")

    //disabled the submit button until this js file is loaded
    const submitBtn = form.querySelector("button[id=\"sendBenefit\"]")
    submitBtn.disabled = false


    form.addEventListener(
        "submit",
        (event) => {
            console.log("running button");
            event.preventDefault()
            event.stopPropagation()
            let href = "/meine-vorteile?"

            //TITLE
            let title = document.getElementById("title").value
            if (title) {
                href = `${href}title=${title}`
            }

            //DISTRICTS
            let districts = document.getElementsByName("districts")
            let queryParamDistrict = ""
            for (let i = 0; i < districts.length; i++) {
                if (districts[i].checked) {
                    queryParamDistrict += districts[i].value + ","
                }
            }
            if (queryParamDistrict.length > 0) {
                queryParamDistrict = queryParamDistrict.substring(
                    0,
                    queryParamDistrict.length - 1
                )
                let symbol = ""
                if (title) {
                    symbol = "&"
                }
                href = `${href}${symbol}bezirke=${queryParamDistrict}`
            }


            //CATEGORIES
            let category = document.getElementsByName("kategorien")
            let queryParamCategory = ""
            for (let i = 0; i < category.length; i++) {
                if (category[i].checked) {
                    queryParamCategory += category[i].value + ","
                }
            }
            if (queryParamCategory.length > 0) {
                queryParamCategory = queryParamCategory.substring(
                    0,
                    queryParamCategory.length - 1
                )
                let symbol = ""
                if (title || queryParamDistrict) {
                    symbol = "&"
                }
                href = `${href}${symbol}kategorien=${queryParamCategory}`
            }

            if (queryParamCategory.length > 0 || title || queryParamDistrict.length > 0) {
                document.location.href = href
            } else {
                document.location.href = "/meine-vorteile"
            }
        },
        false
    )
})()
